export const maxFilePreviewSize = 10 * 1024 * 1024;
